import { Component, OnInit, Input } from '@angular/core';
import { Request } from 'src/app/models/models';
import { NavParams, ModalController } from '@ionic/angular';
import { AdvertAutoCompleteService } from 'src/app/services/advert-auto-complete.service';

@Component({
  selector: 'app-request-form',
  templateUrl: './request-form.component.html',
  styleUrls: ['./request-form.component.scss'],
})
export class RequestFormComponent implements OnInit {

  searchKeyword: string;
  @Input() request: Request;
  @Input() callback: any;
  launchDownloadOnSave = true;
  receivedAfter: string;
  receivedBefore: string;

  constructor(
    public modalCtrl: ModalController,
    navParams: NavParams,
    public advertAutoCompleteService: AdvertAutoCompleteService ) {
    this.request = navParams.get('request');
    this.callback = navParams.get('callback');
  }

  ngOnInit() {
    this.receivedAfter = this.request.receivedAfter ?  new Date(this.request.receivedAfter).toDateString() : null;
    this.receivedBefore = this.request.receivedBefore ?  new Date(this.request.receivedBefore).toDateString() : null;

  }

  dismiss() {
    // using the injected ModalController this page
    // can "dismiss" itself and optionally pass back data
    this.modalCtrl.dismiss({
      'dismissed': true
    });
  }

  save(request: Request) {
    request.receivedAfter = Date.parse(this.receivedAfter);
    request.receivedBefore = Date.parse(this.receivedBefore);
    this.callback(request, this.launchDownloadOnSave);
    this.dismiss();
  }


  advertSelected(title: string) {
    const idx = title.indexOf('-');
    if (idx > 0) {
      this.request.advertId = title.substring(0, idx).replace('Ref:', '').trim();
      this.request.emailSubject = title.substring(idx + 1).trim();
    }
  }


}
